import { Paragraph, Title } from '@ui';
import { Flex, Button } from 'antd';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  icon?: ReactNode;
  title: string;
  message: string;
  okText?: string;
  onOk(): void;
  onCancel(): void;
}

const ConfirmModalContent: FC<IProps> = ({
  icon,
  title,
  message,
  okText,
  onCancel,
  onOk
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      align="center"
      vertical
      gap={40}
      style={{
        // padding: '0 40px 40px',
        textAlign: 'center',
        paddingRight: 0
      }}
    >
      {icon}
      <Flex vertical gap={16}>
        <Title fontWeight="700" level={3}>
          {title}
        </Title>
        <Paragraph textAlign="center" size="18" fontWeight="500">
          {message}
        </Paragraph>
      </Flex>
      <Flex gap={16} justify="center">
        <Button
          style={{ borderRadius: 2 }}
          type="default"
          size="large"
          onClick={onCancel}
        >
          {t('common.cancel')}
        </Button>
        <Button
          style={{ borderRadius: 2 }}
          size="large"
          type="primary"
          onClick={onOk}
        >
          {okText || t('common.yes')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default ConfirmModalContent;
